// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__duLUl","searchBox":"Search_searchBox__5A5Uo"};